import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { AssetsUrlPipe } from '../../../pipes/assets-url.pipe';

@Component({
  selector: 'al-faq',
  standalone: true,
  imports: [CommonModule, AssetsUrlPipe],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  @Input() isClientNotEnrolled = false;
  @Input() source = '';

  faqs = [
    {
      question: 'O que é Passaporte Decolar?',
      answer:
        'Passaporte Decolar é o programa de fidelidade da Decolar que permite acumular pontos e trocá-los por descontos e benefícios exclusivos.',
      open: false,
    },
    {
      question: 'Por que ganho pontos Passaporte Decolar ao pedir no iFood?',
      answer:
        'O iFood e a Decolar se uniram e vão te levar para viajar. A cada pedido que fizer no iFood, você recebe parte do valor de volta, em forma de pontos Decolar.',
      open: false,
    },
    {
      question: 'Quantos pontos eu ganho na Decolar após pedir no iFood?',
      answer:
        'Se você tem Clube iFood, recebe de volta 5% do valor de cada pedido que fizer, convertidos em pontos Decolar. Caso não tenha Clube, você recebe 2%. Além disso, existem ações especiais, em que a pontuação é variada.',
      open: false,
    },
    {
      question: 'Há um limite para acumular pontos?',
      answer:
        'Para as compras feitas diretamente na Decolar, não há limite para o acúmulo de pontos Passaporte. Mas existe um limite mensal para o acúmulo de pontos através do iFood. Se atingido, o acúmulo é interrompido e retorna no mês seguinte. Para saber mais, acesse sua conta no iFood.',
      open: false,
    },
    {
      question: 'Preciso pagar para ganhar pontos na Decolar?',
      answer: 'Não, o acúmulo de pontos Passaporte Decolar é grátis. ',
      open: false,
    },
    {
      question: 'Qual é a validade dos pontos?',
      answer:
        'Os pontos Passaporte Decolar que você acumular com os pedidos no iFood são válidos por 3 meses. Já a validade dos pontos que você acumular em ações especiais, pode variar. Consulte seu extrato no Passaporte Decolar para mais detalhes. ',
      open: false,
    },
    {
      question: 'Há outras formas de ganhar pontos na Decolar?',
      answer:
        'Ao fazer qualquer compra na Decolar, você também ganha pontos Passaporte para trocar por viagens.',
      open: false,
    },
    {
      question:
        'Que outros benefícios tenho pela parceria do iFood com a Decolar?',
      answer:
        'Além de acumular pontos Passaporte Decolar a cada pedido que fizer no iFood e acessar ofertas exclusivas, com Clube você tem: - Até 25% off em hotéis selecionados - Até 15% off em aluguel de carros nos EUA - 25% off em seguro viagem.',
      open: false,
    },
  ];

  toggleFaq(index: number) {
    this.faqs[index].open = !this.faqs[index].open;
  }

}
